import articleDamaged from './ic-hc-article-damaged.svg';
import articleWrong from './ic-hc-article-wrong.svg';
import clothHang from './ic-hc-cloth-hang.svg';
import location from './ic-hc-location.svg';
import missingArticle from './ic-hc-missing-article.svg';
import returnLabel from './ic-hc-return-label.svg';
import tracking from './ic-hc-tracking.svg';
import account from './il-hc-account.svg';
import basket from './il-hc-basket.svg';
import cod from './il-hc-cod.svg';
import complaint from './il-hc-complaint.svg';
import coupons from './il-hc-coupons.svg';
import danger from './il-hc-danger.svg';
import bin from './il-hc-delete.svg';
import delivery from './il-hc-delivery.svg';
import gift from './il-hc-gift.svg';
import higherPriceCheckout from './il-hc-higher_price_checkout.svg';
import newsletter from './il-hc-newsletter.svg';
import orderAndRefund from './il-hc-order_and_refund.svg';
import orderByPhoneSocial from './il-hc-order_by_phone_social.svg';
import orderConfirmationMissing from './il-hc-order_confirmation_missing.svg';
import other from './il-hc-other.svg';
import parcelReturn from './il-hc-parcel-return.svg';
import parcel from './il-hc-parcel.svg';
import payment from './il-hc-payment.svg';
import personalData from './il-hc-personal-data.svg';
import reselle from './il-hc-resell.svg';
import warning from './il-hc-warning.svg';

export const HCIcons = {
  articleDamaged,
  articleWrong,
  clothHang,
  location,
  missingArticle,
  tracking,
  account,
  basket,
  complaint,
  danger,
  bin,
  delivery,
  gift,
  newsletter,
  orderAndRefund,
  other,
  parcelReturn,
  parcel,
  payment,
  personalData,
  reselle,
  warning,
  returnLabel,
  cod,
  coupons,
  higherPriceCheckout,
  orderByPhoneSocial,
  orderConfirmationMissing,
};
